import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={185.21}
        className={props.clase}
      viewBox="0 0 185.21 174.737"
      {...props}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          fill="#FEE181"
          d="M97.532 160.238c-16.208 2.073-31.128-1.683-45.046-9.964 6.096-4.549 13.274-4.715 20.341-4.57 9.259.189 16.015 6.267 23.307 10.929 1.187.76 2.627 1.754 1.398 3.605z"
        />
        <path
          fill="#7149CD"
          d="M26.479 44.169c.313-1.206.909-2.226 1.954-2.947 1.967-.919 2.975-3.076 5.017-3.904 13.964-7.966 28.745-14.013 44.111-18.645 4.416-1.331 9.258-.187 13.612-2.101 4.965.524 9.874-.376 14.805-.507 2.842-.076 6.797-1.599 7.958 3.139-5.449 3.409-11.765 2.492-17.688 3.542-8.062 1.428-16.389 1.251-24.23 3.999-.64.224-1.176.601-1.342 1.338-.593.862-1.486 1.149-2.445 1.328-6.313-.669-11.018 4.22-16.932 4.916-5.813 1.03-10.256 4.609-14.812 7.979-.38.261-.793.452-1.23.591-3.315-.757-5.339 3.993-8.913 2.095-.08-.041-.108-.268-.084-.393.031-.152.142-.287.219-.43z"
        />
        <path
          fill="#FDCF6C"
          d="M51.493 149.568c-1.269-.31-2.323-.956-3.128-1.994-.354-2.68 1.549-4.261 3.467-4.746 5.508-1.397 10.302-4.688 15.92-5.71 5.494-.423 10.984-.68 16.457.124 1.242 1.782 1.242 1.782-.879 2.173 5.672 4.372 11.936 8.202 18.064 12.231 2.719 1.946 5.57 3.752 7.348 6.728-1.496 1.239-3.305.871-5.021.98-2.75.781-5.054-.539-6.771-2.215-6.202-6.055-13.544-9.756-21.833-12.072-6.506-1.818-12.559-1.301-18.105 2.39-1.793 1.191-4.266-.021-5.519 2.111z"
        />
        <path
          fill="#9143C3"
          d="M146.894 34.127c1.471 1.188 2.755 2.534 3.599 4.252.217 1.033-.48 1.263-1.251 1.431-7.207-5.037-16.373-3.282-24.027-6.907-2.119-1.004-4.575-.133-6.834.504-4.688.864-9.237-.712-13.894-.724a308.469 308.469 0 00-25.872 1.01c-2.455.2-4.992.306-7.379-.654a1.755 1.755 0 01-.994-1.214c1.265-2.573 3.35-1.283 5.203-1.097.495.05.994.04 1.491.057-.578-.127-1.193.021-1.755-.219-.291-.123-.511-.362-.702-.706.762-1.968 2.6-1.718 4.175-1.941 13.962-1.987 27.966-2.659 42.04-1.372 4.157.381 8.167 1.176 12.076 2.716 2.136.841 4.486 1.186 6.841 1.1 3.22-.281 4.616 2.966 7.283 3.764z"
        />
        <path
          fill="#FDD978"
          d="M51.493 149.568c-.108-.484-.453-1.29-.293-1.407 8.577-6.288 23.788-6.865 32.915-1.411 3.891 2.325 8.975 3.609 11.545 6.904 2.367 3.034 5.08 4.234 8.059 5.699-1.905 1.389-4.095.793-6.187.885-.642-2.851-3.392-3.427-5.335-4.794-5.9-4.149-12.065-8.075-19.404-8.763-5.231-.49-10.426.997-15.54 2.217-1.606.384-3.179.913-4.767 1.376l-.993-.706z"
        />
        <path
          fill="#E71F81"
          d="M164.59 101.411c.006 1.416-.02 2.824-1.006 3.99-1.164-.459-1.919-1.37-2.34-2.469-1.288-3.359-3.266-5.826-6.549-7.742-2.739-1.6-3.773-5.27-6.521-7.356-1.515-1.15-3.394-2.146-4.372-3.992-.545-1.529-.518-3.038.144-4.528.582-.954 1.403-1.53 2.539-1.602 7.1 2.934 10.839 9.752 16.471 14.405 2.724 2.252 2.413 5.948 1.634 9.294z"
        />
        <path
          fill="#EE1D78"
          d="M144.557 84.263c2.942-.559 4.303 2.077 5.403 3.612 4.32 6.025 12.352 9.187 13.624 17.526-1.612 1.696-.107 4.414-1.976 6.026-1.06-.63-1.34-1.811-1.963-2.751-1.567-3.438-3.106-6.899-5.718-9.714-2.407-2.596-5.374-4.209-8.891-4.791-.765-.762-1.227-1.685-1.51-2.715-.277-2.486-.966-5.034 1.031-7.193z"
        />
        <path
          fill="#DE2189"
          d="M164.59 101.411c.083-4.304-.808-7.873-4.798-10.656-2.681-1.871-5.394-4.069-6.767-7.658-.926-2.422-5.4-1.667-6.494-4.844-2.09-1.062-2.306-2.731-1.542-4.72 1.591-1.79 2.674-.492 4.151.416 5.847 3.594 10.864 8.125 15.583 13.048 1.786 2.688 1.498 5.595.908 8.533-.03 2.017.124 4.066-1.041 5.881z"
        />
        <path
          fill="#575FDC"
          d="M70.585 11.412l1.597-.283c2.104-.579 4.072.102 6.055.65 1.002 4.117-2.391 3.981-4.675 4.566-6.099 1.561-12.001 3.594-17.607 6.46-6.464 1.774-11.671 6.057-17.62 8.864a2.076 2.076 0 01-1.355-.355c4.578-5.935 10.627-9.949 17.248-13.218 1.307-.222 2.959.203 3.325-1.779.767-.731 1.626-1.253 2.739-1.189 3.617-.138 6.89-1.806 10.422-2.374.95-.152-.753-.808-.129-1.342z"
        />
        <path
          fill="#FDAC54"
          d="M118.57 155.28c-.739.896-1.772 1.017-2.83 1.072-2.39.814-4.194-.254-5.575-2.003-2.95-3.738-6.007-7.348-9.569-10.544-1.638-1.47-2.602-3.423-1.307-5.724 2.59-1.374 5.271-.771 7.943-.354 2.805 6.477 8.41 11.151 11.338 17.553z"
        />
        <path
          fill="#F61F6D"
          d="M144.572 92.257c.78.444.945 1.186.967 1.997 4.897 1.652 6.795 6.599 10.496 9.563 1.655 1.326 2.195 3.777 4.499 4.442 1.211.767.933 2.039 1.074 3.169-.228 1.823-.838 3.487-2.033 4.909-1.772.618-2.759-.499-3.722-1.68-3.611-4.435-6.409-9.54-11.037-13.148-.856-.668-1.051-2.019-1.325-3.152-.243-2.142-.728-4.328 1.081-6.1z"
        />
        <path
          fill="#FD5411"
          d="M25.756 124.193c-1.371-1.826-2.67-3.691-3.211-5.964 3.688-5.146 7.913-9.425 14.902-9.254.393.314.686.708.886 1.169.292 7.026-3.763 11.555-12.577 14.049z"
        />
        <path
          fill="#EB304C"
          d="M17.412 104.517c-.825-2.358-2.293-4.564-1.719-7.255 5.342-4.234 11.435-7.22 17.357-10.492 1.181-.651 2.24-1.491 3.667-.717.959.981 1.331 2.245 1.721 3.505.466 2.396.698 4.786-.208 7.139a1.545 1.545 0 01-1.203.867 1.615 1.615 0 01-1.137-.863c-.594-1.01-.279-2.26-.999-3.623-5.891 3.762-12.403 6.46-17.479 11.439z"
        />
        <path
          fill="#8540BE"
          d="M19.498 58.255c.215-1.857.875-3.533 2.049-4.999 3.313-5.381 8.916-7.851 13.984-11v-.001c1.979-1.01 3.693-2.583 6.035-2.828 1.385-.054 2.504.442 3.3 1.602.785 2.505-.688 3.743-2.64 4.716-6.229 2.825-11.756 6.813-17.436 10.552-1.603 1.056-2.963 2.835-5.292 1.958z"
        />
        <path
          fill="#F43742"
          d="M17.412 104.517c.535-4.958 5.398-5.468 8.404-7.579 3.121-2.191 6.709-3.938 10.035-6.181 1.188 1.97.462 3.791.654 5.511-4.953 5.57-12.465 7.309-17.992 12.019-.961-1.084-1.083-2.412-1.101-3.77z"
        />
        <path
          fill="#CF2594"
          d="M165.512 73.285a.734.734 0 01.083.794c.754 1.436.298 2.981.408 4.475-.394 1.438-1.198 2.643-2.168 3.751-3.05.798-4.839-1.276-6.69-3.048-3.388-3.243-7.359-5.785-10.712-9.027-1.092.049-1.514 1.491-2.717 1.311a2.28 2.28 0 01-.974-1.021c-.776-2.263-.527-4.594-.535-6.908.055-1.054.221-2.08.761-3.006.3-.45.726-.665 1.266-.645 1.452.716 1.391 2.44 2.335 3.497 4.338 5.188 9.93 8.445 16.242 10.56.973.041 1.58-1.33 2.701-.733z"
        />
        <path
          fill="#A337B9"
          d="M154.561 44.242c1.797 2.068 3.19 4.366 3.968 7.012-1.818 1.602-3.332.244-4.947-.47-4.937-2.181-9.651-5.051-15.308-5.063-1.006-.354-1.413-1.123-1.471-2.129 1.159-1.545-1.813-3.741.789-5.074.905-.288 1.803-.232 2.696.041 1.416.636 2.734 1.517 4.317 1.746 1.077.285 2.146.6 3.234.844 2.473.529 4.204 2.661 6.722 3.093z"
        />
        <path
          fill="#FD3846"
          d="M152.723 128.322c-1.333 1.757-2.075 3.965-4.021 5.25-4.703-3.384-8.164-7.521-8.325-13.677.091-1.754.466-3.397 1.799-4.666 3.966.456 4.583 4.477 6.883 6.694 1.698 1.64 2.807 4.051 3.664 6.399z"
        />
        <path
          fill="#655ADA"
          d="M103.828 10.158c4.965.307 9.647 1.613 14.044 3.941-1.462 2.177-3.695 1.729-5.775 1.624-2.438-.123-4.868-.438-7.305-.019-3.513-.621-7.038-.945-10.612-.604-1.74.167-3.597.68-4.928-1.097.01-1.814.992-3.073 2.326-4.143 4.11-1.023 8.17.072 12.25.298z"
        />
        <path
          fill="#9338B5"
          d="M19.498 58.255c6.441-4.118 12.881-8.24 19.328-12.349.875-.558 1.703-1.851 2.831-.324.423 1.871-.271 3.333-1.651 4.549-6.807 4.1-13.199 8.825-19.824 13.202-.801.528-1.505 1.36-2.646.925.108-2.18.756-4.183 1.962-6.003z"
        />
        <path
          fill="#FEB75B"
          d="M99.532 138.313c.009.331-.114.756.045.979 4.604 6.425 9.017 13.039 16.162 17.06-.843.883-1.942.957-3.061.975-4.908.273-7.187-3.063-9.252-6.711-2.741-2.365-5.649-4.525-8.266-7.023-2.081-1.985-2.957-4.017-.06-6.076 1.615-.488 3.16-.599 4.432.796z"
        />
        <path
          fill="#FA295D"
          d="M157.443 120.238c-.147 2.159-1.455 3.691-2.807 5.201-3.521-5.647-8.435-10.267-11.83-16.015-.253-.999-.254-1.99.094-2.97a3.316 3.316 0 011.482-1.583c.645-.197 1.37-.335 1.908.088 5.141 4.049 9.014 9.035 11.153 15.279z"
        />
        <path
          fill="#FC2F52"
          d="M143.664 109.254c.746 2.593 3.064 4.294 4.752 5.799 3.313 2.955 4.718 6.595 6.221 10.387-.217 1.241-.916 2.161-1.914 2.883-1.338-.06-1.821-.897-2.363-2.052-1.919-4.089-4.992-7.417-7.651-11.018-1.87-2.349-.888-4.242.955-5.999z"
        />
        <path
          fill="#A92F9F"
          d="M16.158 69.104c.036-.318.159-.599.369-.841a7.407 7.407 0 013.222-4.229c4.665-2.85 8.872-6.364 13.562-9.164 2.965-1.771 5.056-1.461 5.553 2.447-.045 6.76.936 13.546-.594 20.258-.301.589-.783.854-1.441.802-1.416-.94-1.489-2.442-1.643-3.911-.146-1.661.055-3.328-.043-4.99-.011-1.789.09-3.579.075-5.365-.018-.893.066-1.794-.115-2.668-1.712-1.648-2.454.685-3.694.905a7.151 7.151 0 01-1.253.572c-4.035 1.486-6.819 4.724-10.061 7.296-2.096 1.663-3.199 1.297-3.937-1.112z"
        />
        <path
          fill="#B82891"
          d="M36.495 60.253l-.015 3.01c-.541.742-.936 1.601-1.695 2.173-5.011 4.658-11.428 7.423-16.379 12.175-.861.826-1.793 1.488-1.663 2.843.01.936.018 1.866-.021 2.8-.05.988-.199 1.948-.766 2.793-.38.396-.813.444-1.29.191-.185-4.022-.534-8.056.821-11.972C20 69.632 25.641 66.414 30.533 62.259v-.001c2.037-.52 3.377-3.114 5.962-2.005z"
        />
        <path
          fill="#9E32AB"
          d="M37.666 56.482c-.269-1.669-.88-2.494-2.607-1.25-6.127 4.414-12.856 7.972-18.531 13.031-.111-1.448.178-2.795 1.008-4.006 6.963-5.645 14.274-10.771 22.23-14.938 1.021 2.894.912 5.453-2.1 7.163z"
        />
        <path
          fill="#AA35B1"
          d="M138.486 45.372c6.19-2.256 10.403 2.835 15.586 4.309 1.468.417 2.678 1.814 4.456 1.573 2.071 3.017 3.403 6.335 4.064 9.929.466.995-.149 1.24-.944 1.362-1.513-.521-2.106-1.877-2.84-3.107-2.154-6.167-8.266-7.238-13.031-9.991-1.278-.738-2.536.224-3.405 1.374a2.51 2.51 0 01-1.209.689c-2.281-1.441-2.952-3.583-2.677-6.138z"
        />
        <path
          fill="#6D50D2"
          d="M104.535 15.253c4.258-2.554 9.019.711 13.336-1.153 2.107.201 3.878 1.218 5.614 2.315-2.27 2.807-5.666 2.756-8.769 3.462a2.194 2.194 0 01-1.186-.622c-2.085-2.975-5.154-2.006-7.984-1.991-4.672.023-9.344 1.921-14.016-.006 3.839-3.894 8.65-1.475 13.005-2.005z"
        />
        <path
          fill="#FDC66A"
          d="M66.531 138.263c-4.696 1.703-8.826 4.743-14.037 5.369-1.512.182-2.76 2.565-4.129 3.941-1.209-.357-2.242-.97-2.961-2.04-.566-1.116-.017-2.083.808-2.56 3.979-2.3 7.049-6.024 11.604-7.419 3.126.188 6.399-.083 8.715 2.709z"
        />
        <path
          fill="#E52856"
          d="M36.488 86.24c-5.145 3.704-11.685 5.101-16.23 9.781-1.313 1.352-2.934 1.236-4.564 1.239l-.27-2.734a3.172 3.172 0 01-.277-2.012c1.354-.297 3.041.813 4.037-.968 3.281-1.932 5.856-4.861 9.275-6.608 2.971.364 5.342-3.027 8.522-1.367.4.995.369 1.909-.493 2.669z"
        />
        <path
          fill="#F92264"
          d="M157.443 120.238c-4.215-5.081-6.816-11.552-12.924-15.002-1.635-2.011-1.661-4.006.055-5.985 6.127 4.706 9.05 12.226 15.001 17.086.076 1.73-1.342 2.644-2.132 3.901z"
        />
        <path
          fill="#7852D0"
          d="M114.533 19.257l8.952-2.842c4.776 1.954 9.087 4.661 12.996 8.021-.025 1.447-1.051 1.391-2.054 1.375-4.617-2.126-9.369-3.503-14.545-3.681-1.878-.066-4.793.31-5.349-2.873z"
        />
        <path
          fill="#FE7C2A"
          d="M30.609 131.217l-2.098-2.951c.234-.861.791-1.544 1.597-1.775 4.207-1.209 6.954-4.239 9.554-7.482 2.18.368 2.486 2.155 2.93 3.844-.336 6.58-4.708 9.63-11.983 8.364z"
        />
        <path
          fill="#5968DF"
          d="M103.828 10.158c-4.07.687-8.357-1.043-12.299 1.097-4.229 1.705-8.496 2.881-13 1.002-2.245.354-4.23-.748-6.346-1.128 10.465-3.019 21.003-3.727 31.645-.971z"
        />
        <path
          fill="#FD471B"
          d="M37.594 109.266c-6.237.938-10.274 5.57-15.049 8.964l-1.197-2.582c-.162-.481-.205-.971-.02-1.452 1.778-4.632 11.654-9.296 16.556-7.823.521 1.025.52 2-.29 2.893z"
        />
        <path
          fill="#FE9E4A"
          d="M118.57 155.28c-5.146-3.403-6.45-9.983-11.264-13.726-.496-.386.117-2.197.215-3.348a1.864 1.864 0 011.196-.349c1.061.194 2.092.467 2.941 1.188.646 1.764 1.215 3.577 2.948 4.663.315.325.576.685.799 1.077 1.134 4.045 5.177 5.592 7.435 8.667-1.238 1.041-2.658 1.659-4.27 1.828z"
        />
        <path
          fill="#FA3A36"
          d="M18.514 108.286c.348-2.499 2.65-3.521 4.269-4.561 4.37-2.805 9.123-5.013 13.724-7.458.02.327.033.655.043.982.539.567.653 1.235.479 1.974-5.394 4.564-11.691 7.73-17.686 11.368-.746-.6-.857-1.428-.829-2.305z"
        />
        <path
          fill="#FDB962"
          d="M57.518 136.43c-3.879 3.245-8.571 5.406-12.112 9.103-2.122-.884-3.743-2.388-5.144-4.162 4.632-1.593 8.471-4.463 12.173-7.564 2.145 0 4.216.148 5.083 2.623z"
        />
        <path
          fill="#FE6017"
          d="M138.779 143.372c-.805 1.68-2.836 1.767-3.949 3.045-5.725-.51-8.078-3.247-9.594-11.154.868-1.695 2.282-2.437 4.153-2.379 2.127.919 2.398 3.057 3.052 4.871.875 2.428 2.352 3.929 5.012 4.075.677.314 1.134.815 1.326 1.542z"
        />
        <path
          fill="#FDAD58"
          d="M52.513 134.448c-3.074 4.093-6.478 7.603-12.251 6.922l-1.905-1.708c-.526-.678-.231-1.46.355-1.579 4.336-.879 6.784-4.27 9.683-7.08 2.384-.06 3.65 1.216 4.118 3.445z"
        />
        <path
          fill="#FE8F3A"
          d="M111.531 139.257c-1.107-.039-2.301.168-3.006-1.039.569-.65 1.316-.958 2.14-1.123 1.872-.19 3.739-.29 5.519.517 3.192 4.873 6.385 9.755 10.635 13.823l-1.909 1.031c-5.26-.461-8.085-3.999-10.378-8.21v-.001c-1.699-1.247-2.204-3.21-3.001-4.998z"
        />
        <path
          fill="#FD7827"
          d="M131.84 148.441c-.825.991-1.828 1.693-3.121 1.924-5.763-1.596-9.281-6.38-8.512-11.293.052-.331-2.066-.343-1.859-1.876 1.205-1.512 2.773-1.998 4.638-1.645.463.168 1.114.396 1.175.801.77 5.182 4.354 8.549 7.679 12.089z"
        />
        <path
          fill="#FE6316"
          d="M25.756 124.193c3.155-1.833 5.487-4.719 8.947-6.301 3.021-1.381 2.574-4.997 2.982-7.873 2.809 1.112 1.932 3.585 2.11 5.671-2.465 8.393-6.329 11.175-13.298 9.582l-.741-1.079z"
        />
        <path
          fill="#FC3E2E"
          d="M19.342 110.592c4.609-5.459 11.187-7.939 17.161-11.332 1.078.755 1.396 1.938 1.756 3.1.198.967.185 1.907-.381 2.77-3.903-1.292-6.788.938-9.784 2.819-2.668 1.677-5.121 3.649-7.664 5.499-.917-.742-1.002-1.8-1.088-2.856z"
        />
        <path
          fill="#FD4634"
          d="M146.479 136.147c-.703 1.298-1.677 2.332-2.974 3.051-3.083-3.641-6.419-7.128-7.365-12.076.192-.822.734-1.271 1.538-1.444 5.871 1.304 7.809 3.611 8.801 10.469z"
        />
        <path
          fill="#FE6C1E"
          d="M131.84 148.441c-5.584-2.187-7.946-6.562-8.34-12.274.17-1.599.973-1.535 2.039-.774 2.351 4.304 3.554 9.574 9.291 11.024-.771 1.008-1.726 1.744-2.99 2.024z"
        />
        <path
          fill="#FEA250"
          d="M48.512 131.507c-1.85 4.63-5.637 6.848-10.155 8.155-1.307-.683-2.409-1.569-2.991-2.979-.339-.954-.004-1.606.966-1.795 3.864-.75 6.673-3.114 9.21-5.923 1.735-.025 2.736.811 2.97 2.542z"
        />
        <path
          fill="#FD4225"
          d="M20.43 113.447c2.492-4.349 6.881-6.463 10.902-8.881 1.799-1.081 4.32-1.877 6.066.691.236.217.318.438.248.664-.07.228-.145.342-.221.342-6.319 1.482-12.313 3.521-16.078 9.384-.767-.54-.9-1.346-.917-2.2z"
        />
        <path
          fill="#AF2897"
          d="M30.533 62.259c-.217 3.485-3.376 3.846-5.535 5.353-3.172 2.214-5.614 5.464-9.51 6.654.156-1.729-.486-3.562.67-5.161.976.021 1.098 1.874 3.034.457 3.597-2.632 5.935-7.475 11.341-7.303z"
        />
        <path
          fill="#FD8D3B"
          d="M30.609 131.217c2.309-1.053 4.867-.935 7.311-1.999 3.086-1.345 3.76-3.128 3.606-5.931 2.153-.318 2.206 1.428 2.706 2.741-.049 6.506-5.124 7.839-9.84 9.543-1.548-1.201-2.908-2.567-3.783-4.354z"
        />
        <path
          fill="#FE8530"
          d="M118.535 137.345c3.176 1.332 1.96 5.149 4.313 7.394 1.916 1.827 3.702 3.949 5.871 5.627l-1.9 1.069c-5.525-2.744-9.027-7.067-10.269-13.155.082-.623.434-1.043.983-1.315.401-.052.738.067 1.002.38z"
        />
        <path
          fill="#FD4C2B"
          d="M136.807 127.271c1.458 4.41 5.782 7.212 6.699 11.927-.42.891-1.021 1.575-2.033 1.797-.829-.178-1.794-.461-2.034-1.241-1.193-3.877-4.658-5.769-7.188-8.478.498-2.495 2.292-3.517 4.556-4.005z"
        />
        <path
          fill="#7749C7"
          d="M35.531 42.256c-3.748 4.828-9.816 6.707-13.984 11 .977-3.391 2.734-6.358 4.933-9.087 1.504 1.108 3.173.245 3.708-.726 1.476-2.68 3.414-1.544 5.343-1.187z"
        />
        <path
          fill="#FD4140"
          d="M146.479 136.147c-2.145-4.008-3.47-8.749-8.84-9.866-.366-3.056 1.155-5.022 3.695-6.4.118 5.821 4.531 9.332 7.366 13.691-.395 1.156-1.143 2.007-2.221 2.575z"
        />
        <path
          fill="#FD501D"
          d="M132.562 131.259c5.275 1.136 6.585 5.901 8.912 9.736l-2.694 2.377-1.25-1.116c-2.153-3.404-5.413-6.087-6.596-10.126.33-.688.747-1.214 1.628-.871z"
        />
        <path
          fill="#FD6C1E"
          d="M26.498 125.272c6.048-.528 10.871-2.656 12.209-9.34 1.729.622 1.784 1.742.933 3.132-.95 6.405-6.55 7.186-11.128 9.201-1.018-.765-1.719-1.743-2.014-2.993z"
        />
        <path
          fill="#854CC9"
          d="M134.525 25.252l1.956-.816c3.982 2.681 7.512 5.848 10.412 9.691-2.924.246-4.489-2.987-7.362-2.874-2.418-1.101-5.158-1.545-7.159-3.501-.948-2.265.084-2.829 2.153-2.5z"
        />
        <path
          fill="#FDC065"
          d="M104.529 150.257c2.109 3.055 4.387 5.917 8.148 7.069-1.115 1.088-2.564.921-3.936 1.048-3.465-.787-4.721-4.182-7.213-6.116-.6-.731-.565-1.48-.059-2.242 1.08-.663 2.089-.455 3.06.241z"
        />
        <path
          fill="#BF34A3"
          d="M161.535 62.25l1.058-1.067c1.731 3.852 2.83 7.855 2.919 12.103l-1.98 2.961c-.802-1.194-1.272-2.538-1.76-3.876.283-3.337-3.378-5.817-2.056-9.386.462-.603.972-1.09 1.819-.735z"
        />
        <path
          fill="#FE9745"
          d="M34.393 135.571c3.118-2.991 8.523-3.72 9.111-9.212 2.263-.412 2.141 1.154 2.162 2.603-.963 5.87-6.455 5.695-10.301 7.72l-.972-1.111z"
        />
        <path
          fill="#D52A93"
          d="M163.529 82.255c-.009-1.436-.043-2.888 1.964-3.007.991.789.109 2.166.944 3.004.204 4.454.639 8.922-.806 13.277-.371-2.842.645-6.037-2.103-8.275-1.111-1.667-1.477-3.333.001-4.999z"
        />
        <path
          fill="#6858D5"
          d="M36.979 31.314a2.45 2.45 0 01.574-.013c.723.579 1.294 1.248 1.321 2.238-1.48 1.909-3.428 3.293-5.341 4.716-1.453 1.414-2.782 3.04-5.1 2.966 2.274-3.798 4.735-7.434 8.546-9.907z"
        />
        <path
          fill="#5968DF"
          d="M70.585 11.412l2.529 1.639c-4.572.79-8.206 3.902-12.823 2.077 3.16-1.99 6.668-3.015 10.294-3.716z"
        />
        <path
          fill="#FE9744"
          d="M114.531 144.256c3.117 3.168 6.184 6.401 10.378 8.209l-2.069.987c-4.138-1.829-7.905-3.993-8.309-9.196z"
        />
        <path
          fill="#A03FBD"
          d="M154.561 44.242c-3.25 2.535-4.374-2.431-7.029-1.993-1.349-2.343.76-2.375 1.998-2.99l.963-.88c1.751 1.68 3.184 3.581 4.068 5.863z"
        />
        <path
          fill="#DA2573"
          d="M15.626 92.362l-.202 2.163c-1.188-2.677-.848-5.493-.757-8.288.276-.007.553-.01.829-.009 1.155-.891 2.289-2.195 3.594-.185.391 1.256-.025 2.337-.727 3.355-.782 1.106-1.72 2.071-2.737 2.964z"
        />
        <path
          fill="#BF34A3"
          d="M166.438 82.252c-1.077-.762-.86-1.93-.943-3.004.033-1.723.066-3.444.101-5.168 1.307 2.617.907 5.412.842 8.172z"
        />
        <path
          fill="#5968DF"
          d="M57.552 16.317c.309.862.913 1.771-.271 2.452-1.209.695-2.051-.379-3.055-.673.893-.994 2.039-1.519 3.326-1.779z"
        />
        <path
          fill="#8443C5"
          d="M132.531 27.255c2.304 1.384 5.548 1.123 7 3.998-2.447 1.284-5.063.215-6.953-.668-5.578-2.608-11.435-2.368-17.261-2.93-8.448-.814-17.046-1.229-25.245.324-4.828.915-9.729-.464-14.263 1.838l4.204 1.471h-9.486c-3.492.85-2.364-1.341-1.996-3.032.821-.023 1.569-.195 2-1 9.196-2.785 18.669-4.305 28.2-4.662 8.918-.333 17.88-.456 26.834.888 3.156.473 5.233 1.409 6.966 3.773z"
        />
        <path
          fill="#6850D5"
          d="M33.533 38.256c1.035-2.298 3.355-3.312 4.998-5.002 1.416-4.038 5.657-4.221 8.572-6.19 2.88-1.946 6.508-2.482 9.391-4.521a141.308 141.308 0 0128.707-8.757c1.459-.279 2.966-.403 4.33.471 4.374-.177 8.756-.26 13.119-.586 1.432-.107 1.715.512 1.885 1.583-4.116 2.083-8.864.071-13.004 2.005-2.574 1.582-5.307 2.078-8.379 2.083-7.314.014-13.89 3.438-20.616 5.664-8.43 2.788-16.343 7.139-24.477 10.822-1.561.706-2.245 3.055-4.526 2.428z"
        />
        <path
          fill="#7A48CB"
          d="M132.531 27.255c-9.781-4.479-20.224-2.396-30.371-3.36-10.967-1.042-20.975 3.558-31.629 3.361-.848-1.05.017-1.504.754-1.75.761-.254 1.693-.034 2.426-.331 4.344-1.756 8.745-2.399 13.487-2.053 3.401.248 6.464-1.93 10.28-1.744 5.304.259 10.697-1.327 16.053-2.123l1.002.002c3.769 2.866 8.418 1.517 12.596 2.522 2.821.679 5.201 1.736 7.396 3.473-.427.903-2.484.186-1.994 2.003z"
        />
        <path
          fill="#814AC7"
          d="M68.531 28.256c.95.823-.289 3.088 1.996 3.032l.008.611c-.521 1.333-1.747 1.463-2.887 1.548-7.294.542-14.065 2.489-19.903 7.115-.778.616-1.755.955-2.812.818l-3.4-1.128c1.571-4.169 6.02-4.636 8.996-6.996 6.285-.643 11.14-6.435 18.002-5z"
        />
        <path
          fill="#7749C7"
          d="M50.529 33.257c-2.185 3.379-6.416 4.125-8.996 6.996-1.938.857-3.691 2.264-6.002 2.002 3.977-4.704 9.114-7.474 14.998-8.998z"
        />
        <path
          fill="#FEFEFD"
          d="M44.934 41.381c7.127-6.959 16.039-9.096 25.602-9.481 8.91-.125 17.823-.161 26.73-.401 7.443-.201 14.848.309 22.26.794 3.842-.45 7.107 1.05 10.241 3.009 3.058 2.26 6.385 4.277 7.621 8.227.04.809.172 1.563 1.099 1.845l2.932 6.095c1.8 1.543 1.895 3.747 2.279 5.843.131 2.087-1.439 4.096-.28 6.232l.194 7.701c.822.945.997 2.103.885 3.267-1.011 10.548.01 21.144-.767 31.694l-.065 3.05-.956 5.999-1.373 4.628c-1.231 2.134-2.464 4.267-3.696 6.4l-.832.99-4.245 3.987-1.088.837c-.431.739-.74 1.655-1.912 1.319l-4.022 1.978c-.812-.089-1.512.115-2.039.774l-4.965 1.178-1.011.048c-2.323.946-4.885-.301-7.192.786l-1.807.039-1.004-.011-7.989.105-4.999.03c-1.735 1.411-3.783 1.323-5.836 1.229-1.19-.077-2.342-.259-3.202-1.209l-18.964-.101-9.014-1.834-5.005-1.981c-1.333-.98-2.667-1.961-4.001-2.94l-2.847-2.544-2.161-2.604a3902.7 3902.7 0 00-1.978-3.072l-1.887-4.222-.933-3.131c-.211-1.994-.082-4.047-1.021-5.914.17-.275.14-.527-.092-.754-.056-1.001-.111-2.002-.168-3.002l-.027-1.006-.048-3.035c-.479-1.652-.431-3.309-.042-4.967l-.032-8.089c.386-3.673-1.974-7.325-.085-11.011l.474-21.674 2.101-7.162 1.892-3.739 3.275-4.2z"
        />
        <path
          fill="#FDC665"
          d="M85.495 138.363l3.012.002c4.033 4.302 9.936 6.557 13.024 11.892l-.002 2.001c-6.189-2.37-11.45-6.275-16.502-10.401-1.143-.935-2.418-1.336-3.631-2.107 1.252-1.024 3.119.105 4.099-1.387z"
        />
        <path
          fill="#983FC0"
          d="M129.586 36.235l-10.061-3.943c2.03-1.826 4.628-1.545 6.529-.572 5.374 2.75 11.188 2.834 16.906 3.501 2.924.34 3.814 3.634 6.568 4.038-.608 1.035-2.158 1.442-1.998 2.99l-3.002-.998c-1.13-1.07-2.838-.979-3.996-1.991l-3.003-.008c-2.862-.439-5.064-2.62-7.943-3.017z"
        />
        <path
          fill="#D33682"
          d="M143.729 106.204l-.118-34.961c.308.009.615.015.922.018.844 2.665.827 5.329 0 7.994l.023 5.008.015 7.994.002 6.994-.054 5.985-.79.968z"
        />
        <path
          fill="#E62892"
          d="M144.533 79.255v-7.994c.042-1.097-.179-2.282 1-3 1.32 1.662 1.326 3.326.008 4.992-.12 1.756.039 3.456.99 5l-1.998 1.002z"
        />
        <path
          fill="#F11D71"
          d="M160.534 108.259c-.795 2.69-1.714.179-2.012-.131-4.386-4.569-8.673-9.232-12.984-13.874 1.319-.476 1.913-1.755 4.13-.323 5.525 3.569 8.806 8.369 10.866 14.328z"
        />
        <path
          fill="#D6228F"
          d="M145.541 73.253l-.008-4.992c4.825 1.764 7.229 6.59 11.589 9.175 2.081 1.234 4.049 3.458 6.407 4.819v4.999c-5.173-4.36-10.419-8.638-15.448-13.157-.913-.821-1.668-.667-2.54-.844z"
        />
        <path
          fill="#5D57DA"
          d="M89.531 14.256c-11.39 1.572-22.083 5.695-32.999 9.002-.553-.116-.888-.45-1.003-1.003 5.033-4.046 11.238-5.269 17.217-6.915 2.258-.621 4.493-.833 5.783-3.083 4.326-.424 8.605-1.459 13-1.002l-1.998 3.001z"
        />
        <path
          fill="#5E59D8"
          d="M55.529 22.255l1.003 1.003c-3.081 3.91-8.343 3.812-12.187 6.542-1.706 1.212-3.851 2.328-5.814 3.454-.793-.417-.973-1.142-.979-1.952 5.759-3.482 10.881-8.225 17.977-9.047z"
        />
        <path
          fill="#DA2573"
          d="M37.191 78.156l.085 11.012c-.931-.796-.673-1.912-.788-2.928l-.018-2.963c-1.279-1.417-1.239-2.961-.443-4.579.204-.182.41-.363.617-.544.182.025.365.026.547.002z"
        />
        <path
          fill="#F43742"
          d="M37.309 97.256l.042 4.967c-1.004-.781-.774-1.915-.847-2.963l.045-2.01.76.006z"
        />
        <path
          fill="#BE279C"
          d="M160.526 63.263c-.69 3.299 3.368 5.538 2.005 8.987-4.721.036-8.146-2.813-11.452-5.545-1.985-1.64-3.783-3.635-5.41-5.667-.449-.129-.046-1.515-1.136-.78-.294.004-.588.01-.881.02-.957-.795-.487-1.885-.593-2.854.638-2.695 2.505-2.934 4.468-1.816 4.369 2.485 8.911 4.69 12.999 7.655z"
        />
        <path
          fill="#C62596"
          d="M145.533 60.256c2.151.04 3.137 2.033 3.995 3.25 3.284 4.651 8.663 5.87 13.003 8.744 1.459 1.051.865 2.615 1 3.997-5.363-2.652-10.759-5.26-15.358-9.178-.974-.83-1.764-1.874-2.64-2.82-.727-1.331-.726-2.662 0-3.993z"
        />
        <path
          fill="#CA35A0"
          d="M145.533 60.256v3.994c-1.465-1.048-.852-2.615-1-3.992l.497-1.303.503 1.301zM143.537 57.248l.113 3.029c-.076 1.087-.154 2.174-.232 3.263-.933-2.011-.798-4.147-.732-6.276.275-.467.558-.496.851-.016z"
        />
        <path
          fill="#A03FBD"
          d="M129.586 36.235c3.469-1.155 5.744.831 7.944 3.017-1.035 1.393 1.556 2.905-.143 4.275l-7.801-7.292zM140.533 39.26c1.712-.098 3.239.175 3.996 1.991-1.713.1-3.239-.174-3.996-1.991z"
        />
        <path
          fill="#FEBE62"
          d="M101.531 150.257c-4.363-3.369-8.742-6.718-13.05-10.156-.276-.221.005-1.141.026-1.735l6.025-.022c-.316 1.595-.665 2.901 1.16 4.229 3.145 2.286 5.91 5.096 8.836 7.686-.999-.002-1.998-.002-2.997-.002z"
        />
        <path
          fill="#D6207C"
          d="M18.533 86.261c-1-1.167-2.028.347-3.037-.032l.045-2.971c5.872-3.097 10.961-7.267 15.904-11.628 1.307-1.554 3.32-1.593 5.011-2.331l.048 4.938c-.994 2.023-3.293 2.733-4.53 4.516-.903 1.03-1.922 1.899-3.243 2.35-3.871.368-6.016 3.572-8.958 5.469-.472.127-.882.012-1.24-.311z"
        />
        <path
          fill="#CC248B"
          d="M36.456 69.299c-.779 1.691-3.383.958-3.93 2.958-.88.63-1.832.634-2.819.323-1.141-1.983.451-3.042 1.561-4.079 1.338-1.251 2.39-2.656 3.259-4.234l1.955-1.004-.026 6.036z"
        />
        <path
          fill="#DA2573"
          d="M31.533 78.253c.423-2.866 3.307-2.686 4.971-4.017.046 1.307.092 2.613.14 3.919l-.171.188c-.701.708-.326 2.331-1.932 2.275-1.367-.324-2.561-.87-3.008-2.365z"
        />
        <path
          fill="#AF2897"
          d="M36.495 60.253c-2.194.051-3.546 2.612-5.962 2.005 1.778-1.292 2.638-5.312 5.962-2.005z"
        />
        <path
          fill="#C12289"
          d="M34.526 64.267c.465 3.995-3.729 5.075-4.997 7.985-2.37 3.016-5.632 5.005-8.574 7.348-1.539 1.225-3.375 2.234-5.388.671.352-3.479 3.26-5.219 5.621-6.635 4.695-2.817 8.89-6.255 13.338-9.369z"
        />
        <path
          fill="#CD1F82"
          d="M15.567 80.271c4.716.286 6.756-4.092 10.257-5.938 1.242-.655 2.043-2.124 3.705-2.081l2.997.005c-4.439 3.541-8.862 7.103-13.33 10.606-1.078.846-2.336 1.211-3.655.395l.026-2.987z"
        />
        <path
          fill="#B42CA4"
          d="M143.537 57.248c-.284.004-.567.01-.852.016l-1.268-5.797.168-1.191c1.384-.563 2.904-1.239 4.225-.271 4.452 3.268 10.08 4.785 13.721 9.243l2.004 3.002-1.009 1.013c-5.04-.488-8.582-4.134-12.864-6.212-1.644-.799-2.816-1.719-4.125.197z"
        />
        <path
          fill="#AE2EAC"
          d="M159.531 59.248c-4.518-2.542-9.455-4.423-13.357-7.93-1.492-1.34-3.25.047-4.588-1.043.451-1.869 1.553-2.505 3.521-2.357 3.99.301 13.074 7.292 14.424 11.33z"
        />
        <path
          fill="#E42561"
          d="M34.531 80.252l1.942-1.91-.003 4.936c-2.631.721-4.645 3.909-7.938 1.981-.077-.215-.154-.43-.234-.645.821-3.248 3.425-3.952 6.233-4.362z"
        />
        <path
          fill="#E42561"
          d="M28.533 85.259c-2.443 3.049-5.365 5.482-9.002 6.996a2.417 2.417 0 01-.682-1.251c1.677-3.588 5.697-5.977 9.68-5.751l.004.006z"
        />
        <path
          fill="#DE2C64"
          d="M19.529 91.254l.002 1.001c-1.26 1.623-2.525 3.031-3.906.106-.153-1.519.552-2.512 1.908-3.104 1.185.147 1.321 1.341 1.996 1.997z"
        />
        <path
          fill="#FE9744"
          d="M111.531 139.257c2.278.898 2.356 3.118 3 4.998-2.912-.519-3.963-2.154-3-4.998z"
        />
        <path
          fill="#FE5513"
          d="M129.562 133.415l1.912-1.319c2 3.397 5.609 5.836 6.056 10.16-2.941 1.563-4.521-.225-5.623-2.513-.972-2.018-1.579-4.212-2.345-6.328z"
        />
        <path
          fill="#FE9744"
          d="M110.332 138.179c2.308-1.083 4.77-.761 7.192-.786l-.976.886-6.216-.1z"
        />
        <path
          fill="#DE2168"
          d="M19.529 91.254c-.953-.379-1.617-1.044-1.996-1.996l1-2.997.998-.009c2.826-2.257 5.727-4.402 8.998-5.989l3.004-2.01 2.998 1.999c-1.893 1.797-5.018 2.115-6.002 5.001-3.34 1.492-7.183 2.226-9 6.001z"
        />
        <path
          fill="#FE7C25"
          d="M52.802 121.155c-1.715-1.617-3.029-3.458-3.278-5.892a1.875 1.875 0 011.344-.592c5.46 1.38 11.087.988 16.313-.284 8.455-2.059 16.078.789 23.953 2.469 6.417 1.368 11.602 5.708 17.861 7.557 2.606.77 1.938 2.231-.072 3.303-2.59.041-5.177.039-7.762.001-1.063-.02.321-2.088-2.194-1.799-4.359.501-8.62-1.85-12.905-3.053-7.561-2.123-15.189-2.617-22.979-1.678-3.399.41-6.862 1.313-10.281-.032z"
        />
        <path
          fill="#FE6F1C"
          d="M109.574 126.997c.046-.462.215-1.302.121-1.332-10.459-3.395-20.116-9.044-31.246-10.623-6.582-.934-12.717 1.886-19.158 1.411-2.942-.218-6.148 1.431-8.759-1.203-.231-1.889 1.237-1.526 2.265-1.674 5.83-.838 11.631-1.913 17.527-2.226 2.834-.149 5.41-1.071 7.802-2.578 5.032 1.113 10.098 2.048 15.165 2.974-1.102 3.431 1.657 3.613 3.711 4.493 5.617 2.408 10.844 5.659 16.656 7.669 1.293.446 3.033 1.1 1.875 3.2l-4.865.283c-.562.415-.926.283-1.094-.394z"
        />
        <path
          fill="#C52491"
          d="M47.688 59.261c-.089-1.084-.57-2.236.538-3.114 6.2-2.818 12.752-4.608 19.366-5.986 6.435-1.34 12.86-3.034 19.527-2.929.76-.142 1.526-.207 2.297-.234 1.259-.037 2.519-.015 3.776-.034.492-.028.986-.022 1.479-.014 2.672-.055 5.304.445 7.963.606 3.867.907 8.491.188 10.608 4.895-.048 1.082-.381 1.947-1.621 2.114-10.737-2.059-21.53-2.333-32.376-.963-8.464.558-16.4 3.34-24.455 5.66-2.278.657-4.742 1.857-7.102-.001z"
        />
        <path
          fill="#FE8F38"
          d="M52.802 121.155c7.112-.628 14.142-1.483 21.377-1.494 9.47-.013 17.489 4.805 26.529 5.671 2.233.214-.187 1.15-.09 1.774-6.073 2.072-12.154.229-18.012-.677-8.703-1.346-17.562.045-26.139-2.133-1.598-.607-2.91-1.549-3.665-3.141z"
        />
        <path
          fill="#BC33A4"
          d="M74.285 42.11c14.514-1.026 29.036-1.535 43.512.301 2.79.354 5.901.978 7.613 3.876-3.173 1.483-5.639 4.495-9.542 4.413a2.512 2.512 0 01-1.181-.832c-.238-2.665-1.928-3.419-4.345-3.604-9.523-.729-19.058-.669-28.596-.653-1.526.003-3.31.892-4.583-.793.989-4.275 4.213-.996 6.112-1.915-2.832-1.182-6.144 1.447-8.99-.793z"
        />
        <path
          fill="#BC2695"
          d="M87.531 48.255c-5.025 1.349-10.252 1.252-15.38 2.334-6.62 1.396-13.036 3.331-19.505 5.16-1.49.421-2.926.497-4.419.397l1.25-2.911c7.524-6.018 16.301-7.96 25.696-7.898 2.486 1.313 5.049-.106 7.563.202 1.975.242 4.358-.239 4.795 2.716z"
        />
        <path
          fill="#B32F9F"
          d="M75.533 46.256c-8.008.431-15.748 1.864-22.84 5.889-.967.549-2.139.736-3.216 1.091 2.515-7.303 8.56-9.735 15.368-10.803 3.088-.483 6.29-.237 9.439-.322h10.705c-2.368 2.599-6.333-.943-7.454 3.137-.445.775-1.185.966-2.002 1.008z"
        />
        <path
          fill="#FE9E4C"
          d="M56.468 124.297c1.663-1.268 3.442-.347 5.195-.402 8.056-.255 16.109.151 23.979 1.539 4.998.881 9.848 2.229 14.975 1.674l8.956-.109 1.095.393c-4.029 1.362-8.203.734-12.288.676-11.407-.166-22.849.891-34.216-.771-2.771-.407-5.551-.927-7.696-3z"
        />
        <path
          fill="#DE1F7E"
          d="M47.336 84.396c-.677-6.369-.91-12.735.066-19.099 2.355-2.926 5.99-2.563 9.07-3.113 6.229-1.112 12.087-4.132 18.609-3.686 1.176.72 3.482-.717 3.674 1.907-2.58 2.92-5.698 5.085-9.26 6.633-7.259-1.758-13.779 1.056-20.387 3.315-.402.138-.482.834-.316 2.274a81.26 81.26 0 01.104 3.823c-.022 1.37.091 2.738-.023 4.107-.113 1.442-.151 2.913-1.537 3.839z"
        />
        <path
          fill="#FD3344"
          d="M132.65 111.69l.132.313-.211.267c-6.85-3.545-13.121-7.898-18.639-13.319-.16-2.369.356-4.46 2.426-5.913 5.886 2.627 10.45 7.088 15.193 11.24 2.182 1.91 1.689 4.789 1.099 7.412z"
        />
        <path
          fill="#FB2C4E"
          d="M132.65 111.69c.884-7.931-6.35-9.623-10.552-13.601-1.745-1.65-4.178-2.553-5.382-4.831-1.432-1.48-.519-2.714.411-3.945 6.479 2.123 11.816 5.964 16.388 10.95.114 3.84.602 7.708-.865 11.427z"
        />
        <path
          fill="#FE6617"
          d="M115.533 127.108c-.125-1.131-.779-1.664-1.87-1.959-6.674-1.804-12.231-6.198-18.8-8.209-3.104-.949-2.424-2.582-1.33-4.542 1.244-1.692 2.984-2.001 4.918-1.774 3.46 4.188 7.64 7.357 12.629 9.637 2.405 1.099 4.569 2.611 7.322 2.864 1.492.137 2.966.605 3.479 2.341-1.979 1.079-4.087 1.653-6.348 1.642z"
        />
        <path
          fill="#FD4621"
          d="M128.849 120.395c-.338.957-.963 1.64-1.919 2.005-.79.209-1.797.726-2.34-.014-4.959-6.754-12.611-9.773-19.334-14.085.056-2.598 1.996-3.198 3.973-3.766 9.262 1.909 15.357 7.751 19.62 15.86z"
        />
        <path
          fill="#FE5C13"
          d="M121.881 125.466c-7.196-1.553-13.517-4.808-19.727-8.786-2.468-1.58-.711-4.86-3.621-5.323.836-2.236 2.551-2.874 4.756-2.62 4.697 6.898 11.369 11.024 19.155 13.581.932.35 1.715.855 1.972 1.903-.602.911-1.529 1.157-2.535 1.245z"
        />
        <path
          fill="#FD3E2E"
          d="M128.849 120.395c-4.562-3.8-7.201-9.536-13.078-12.159-2.133-.952-4.12-2.441-6.486-3.071-.109-1.751.916-2.681 2.378-3.295 9.027 1.893 15.481 6.993 19.229 15.461-.291 1.28-.905 2.347-2.043 3.064z"
        />
        <path
          fill="#FD3B3D"
          d="M130.891 117.33c-.625.052-1.785.215-1.801.139-1.674-8.018-8.362-10.669-14.625-13.78-.891-.441-1.751-.941-2.625-1.415-1.015-2.316.541-2.803 2.261-3.172 6.396 4.054 12.975 7.853 18.471 13.168.108 1.909-.538 3.567-1.681 5.06z"
        />
        <path
          fill="#D61E83"
          d="M75.525 59.253l-28.123 6.045.063-2.013c2.232-3.44 6.049-3.725 9.488-4.581 5.854-1.459 11.602-3.642 17.812-3.161.5.163.899.459 1.207.885.442 1.035.401 1.994-.447 2.825z"
        />
        <path
          fill="#CD208A"
          d="M75.529 56.253c-9.592 1.401-19.181 2.81-28.064 7.032.074-1.342.148-2.683.224-4.024 5.35-.768 10.526-1.995 15.593-4.06 5.126-2.09 10.814-2.025 16.248-2.943-.093 2.573-2.66 2.671-4.001 3.995z"
        />
        <path
          fill="#FD6618"
          d="M77.529 109.39c-1.482 3.836-5.338 3.182-8.009 3.375-6.399.464-12.681 1.506-18.988 2.485l-1.009.014c-.913-1.192-1.123-2.559-.986-4.01.9-1.842 2.322-1.209 3.705-.796 7.678.718 14.77-2.115 22.082-3.629 1.731.025 2.856.81 3.205 2.561z"
        />
        <path
          fill="#FD4420"
          d="M47.751 104.256l-.101-4.023c1.154-3.378 4.035-3.987 7.054-4.563 3.415-.652 6.788-1.523 10.311-.906 1.991 1.402 3.309 3.104 2.54 5.729-6.074 1.592-12.554 1.355-18.387 4.065-.518.11-.99.006-1.417-.302z"
        />
        <path
          fill="#FD5712"
          d="M47.751 104.256c.261-.002.522-.004.784-.004 5.598 1.967 11.102-.076 16.649-.354 1.665-.084 1.713-2.537 3.55-2.194 1.905.379 3.031 1.519 3.362 3.434-.29 2.221-1.898 2.666-3.784 3.169-5.518 1.473-11.235 1.709-16.781 2.95-.998-.617-1.996-.624-2.994-.003-1.033-2.246-1-4.612-.786-6.998z"
        />
        <path
          fill="#F92657"
          d="M133.516 100.264c-2.813.982-3.415-2.107-4.656-3.166-3.515-2.999-8.565-3.729-11.19-7.841-.661-.485-.798-1.171-.751-1.932.22-1.199.566-2.343 1.493-3.215 2.637 1.613 5.269 3.058 8.287 4.1 3.445 1.189 4.009 5.775 6.841 8.049l-.024 4.005z"
        />
        <path
          fill="#FC393B"
          d="M47.539 94.259l-.077-4.991c2.356-2.59 5.749-2.1 8.673-2.53 2.257-.333 4.309-1.063 6.451-1.639.354.332.621.721.8 1.172.442 1.66.487 3.372.702 5.065a2.814 2.814 0 01-.439 1.416c-.322.37-.693.905-1.119.898-4.198-.07-8.309.369-12.344 1.608-.927.285-1.909-.276-2.647-.999z"
        />
        <path
          fill="#F53449"
          d="M62.665 85.27c-2.524 4.74-7.542 1.316-11.046 3.253-.892.493-2.703.821-4.157.745-.021-1.322-.04-2.646-.06-3.969.923-.629.484-2.529 2.014-2.465 4.515.192 8.571-2.114 13.017-2.262.504.084.948.288 1.347.607.763 1.675.199 2.986-1.115 4.091z"
        />
        <path
          fill="#F62262"
          d="M133.539 96.259c-1.263-.003-2.254-.594-2.99-1.55-2.466-3.195-3.961-7.491-9.515-6.642-1.53.233-.7-3.061-2.445-3.807-.515-4.088 2.519-2.479 4.007-2.144 3.594.812 6.131 3.595 9.035 5.675.205.265.334.558.38.876a3.05 3.05 0 01-.02.968c.349-.056.213-.469.477-.629.431-.157.774-.074 1.047.261l.024 6.992z"
        />
        <path
          fill="#FD3D2E"
          d="M47.539 94.259c5.383-.459 10.538-2.734 16.068-2.016 2.057.409 1.789 1.616 1.029 2.993-3.285.981-6.739.969-10.095 1.662-2.763.57-4.843 1.711-6.892 3.334l-.11-5.973z"
        />
        <path
          fill="#F02951"
          d="M62.514 81.149c-4.343 1.218-8.475 3.414-13.25 2.664-.529-.083-1.236.963-1.861 1.485-.215-.285-.236-.585-.066-.901.121-1.363.244-2.725.366-4.086 3.544-2.673 7.675-2.975 11.86-2.759 2.067.108 4.124.637 2.951 3.597z"
        />
        <path
          fill="#FE4C18"
          d="M124.416 124.221c-.63-.324-1.26-.647-1.889-.972-4.394-5.072-10.301-8.149-15.723-11.855-1.118-.765-2.271-1.355-2.563-2.813.275-.458.666-.57 1.154-.383 8.022 2.386 14.837 6.521 19.751 13.483.31.439 1.175.487 1.782.717-.582.959-1.377 1.625-2.512 1.823z"
        />
        <path
          fill="#D52D95"
          d="M132.671 60.218c1.23 3.604.81 7.316.719 11.007-1.787 0-1.706-1.447-2.023-2.589.36-3.305-1.728-4.671-4.408-5.607-1.504-.525-3.382.1-4.546-1.476-.615-1.62.595-2.67 1.201-3.912.801-1.152.734-2.827 2.151-3.612 2.903 1.391 6.221 2.321 6.906 6.189z"
        />
        <path
          fill="#C333A1"
          d="M116.532 49.907c3.292-.391 5.104-4.41 8.878-3.621 1.868 2.756 5.719 4.014 6.01 7.96-2.574.749-4.781-2.688-7.469-.647-2.403-1.37-5.398-1.553-7.419-3.692z"
        />
        <path
          fill="#CC309A"
          d="M124.407 53.342c2.834-3.549 4.699.413 7.013.904 1.154 1.836 1.318 3.879 1.251 5.972-.997-3.633-6.276-2.139-7.122-5.952a1.58 1.58 0 01-.916-.45l-.226-.474z"
        />
        <path
          fill="#E52986"
          d="M132.514 68.251c.059 1.06-.163 2.202.876 2.974l.056 8.044c-.402.292-.813.306-1.237.041-.688-.664-1.112-1.487-1.442-2.373a7.795 7.795 0 01-.328-1.385c-.163-1.672-.156-3.352-.266-5.029.117-1.439-.29-3.432 2.341-2.272z"
        />
        <path
          fill="#EB1E6D"
          d="M132.526 79.268c.307-.003.613-.003.919 0l.069 10a63.938 63.938 0 00-.981-.02c-1.698-3.325-2.21-6.651-.007-9.98z"
        />
        <path
          fill="#DA2573"
          d="M28.529 80.263c-2.554 2.666-5.235 5.14-8.998 5.989 2.254-3.115 4.657-6.008 8.998-5.989z"
        />
        <path
          fill="#FEFDFD"
          d="M105.396 108.198a1.118 1.118 0 00-.849.188c-.249.412-.605.66-1.089.716l-4.926 2.254-5 1.042c-5.57.248-10.91-.727-16.004-3.009l-3.051-1.907c-1.74.216-2.368-.984-2.912-2.289l-2.826-3.021c-.934-.29-1.66-.729-1.361-1.901l-2.742-5.035c-.066-1.093-.201-2.162-1.029-2.993l-.182-1.007c-.859-1.708.078-3.68-.79-5.386.231-.183.241-.376.029-.581l.374-4.004c.178-1.248-.44-2.438-.287-3.685.719-2.586 1.369-5.2 2.885-7.48 1.189-1.465 2.228-3.104 4.162-3.744l8.658-6.344c4.359-4.113 9.74-4.316 15.207-3.749 2.432.252 4.844.946 7.148 1.858 4.354 1.951 7.947 4.925 11.185 8.378 1.358 1.408 2.448 3.009 3.36 4.738.786 1.576 1.627 3.125 2.312 4.754 1.823 3.707.099 7.453.134 11.181l-.134 2.084-.952 4.002-2.616 5.843-2.261 3.172-2.555 2.891c-1.296 1.012-2.592 2.024-3.888 3.034z"
        />
        <path
          fill="#BE289A"
          d="M75.533 46.256c.43-.808 1.18-.98 2.003-1.009 7.522-2.094 15.2-.974 22.772-.704 3.528.125 7.048-.451 10.745.353 3.604.784 5.843.981 4.472 5.263-.318 1.556-1.217 2.413-2.858 2.377-2.492-3.526-6.865-2.597-10.136-4.278-2.666-.654-5.333-1.28-8-.003l-1 .002c-1.333-1.346-2.666-.701-4-.001h-2c-2.871-2.477-6.229-1.517-9.451-1.253-1.032.083-1.897.204-2.547-.747z"
        />
        <path
          fill="#FDFCFC"
          d="M112.667 52.535l2.858-2.377 1.006-.251c3.303-.406 5.88.85 7.877 3.435a.225.225 0 01.008-.024c1.073 1.583.635 3.251.273 4.914l-2.159 3.035c-3.467 3.041-5.38 2.989-10.108-.269-.854-1.058-1.229-2.326-1.569-3.61-.148-1.05-.175-2.066.871-2.738l.943-2.115z"
        />
        <path
          fill="#D0228E"
          d="M111.724 54.649l-.099 2.476c-3.258 1.313-7.122 1.476-9.959.605-8.709-2.67-17.443-.963-26.135-1.474l-.002-.004c-.223-2.891 2.794-2.536 4-3.995 4.606-.903 9.332-.018 13.996-1.296 2.4-.658 5.295.397 7.951.786 2.701.396 5.211 1.931 8.163.777 1.448-.565 1.82.971 2.085 2.125z"
        />
        <path
          fill="#BC2695"
          d="M94.531 48.254c2.667-1.826 5.334-2.863 8 .002-2.667 1.296-5.333-.757-8-.002zM89.531 48.255c1.334-.718 2.668-3.508 4 .001l-4-.001z"
        />
        <path
          fill="#DA268C"
          d="M75.531 56.257c2.144-2.442 5.022-.994 7.48-1.162 6.074-.417 12.283-1.077 18.097 1.697 1.964.938 4.977.095 5.549-.414 2.383-2.117 3.394.446 4.968.747l1.324 3.004c-3.961 2.289-7.709-.719-11.588-.469-7.684-3.037-15.316-2.859-22.904.353-.649-1.517-2.234.577-2.932-.76l.006-2.996z"
        />
        <path
          fill="#E31C74"
          d="M69.799 66.356l-3.131 4.173c-5.467 1.826-11.454 1.226-16.805 3.638-1.783.804-1.66-.974-2.191-1.83-.863-3.596 2.236-4.178 4.272-4.867 3.88-1.314 8.2-.917 12.011-2.839 2.355-1.188 3.647 1.955 5.844 1.725z"
        />
        <path
          fill="#E92069"
          d="M47.672 72.337c.821.738 1.285.761 2.636.327 5.258-1.687 10.693-3.115 16.36-2.135l-3.018 6.945c-3.253-3.234-6.822-2.277-10.457-.829-1.861.742-3.834 2.553-5.506-.319-.004-1.33-.009-2.659-.015-3.989z"
        />
        <path
          fill="#ED245C"
          d="M47.688 76.326c2.146 1.45 3.66-.09 5.376-1.042 4.679-2.598 9.19-1.62 10.586 2.19l-.61 3.791a2.107 2.107 0 01-.525-.115c-.243-1.93-1.08-2.312-3.209-2.495-4.1-.352-7.672 1.709-11.604 1.655l-.014-3.984z"
        />
        <path
          fill="#FD5111"
          d="M103.459 109.103c.151-.56.465-.874 1.089-.716 4.795 4.084 11.042 6.094 15.406 10.793 1.11 1.196 2.603 2.152 2.573 4.069-7.889-2.647-15.884-5.154-19.068-14.146z"
        />
        <path
          fill="#FD5D11"
          d="M71.566 105.193l2.912 2.289c-7.447 2.487-14.807 5.506-22.947 3.774 1.171-.655 1.223-1.938 3.616-2.103 5.484-.376 11.636.044 16.419-3.96z"
        />
        <path
          fill="#FD4C11"
          d="M67.379 100.271l1.361 1.901c-4.062 4.401-15.452 5.573-20.205 2.079 5.68-4.171 12.225-4.255 18.844-3.98z"
        />
        <path
          fill="#F21E6E"
          d="M117.803 87.173c-.034-3.939-.475-7.83-1.407-11.662.221-2.693 2.298-1.749 3.507-1.471 4.88 1.124 9.362 3.04 12.07 7.661-.149 2.186.533 4.429-.451 6.556-2.673-.547-4.371-2.728-6.612-3.918-1.851-.982-4.211-3.603-6.321-.078-.119 1.01.148 2.123-.786 2.912z"
        />
        <path
          fill="#F53449"
          d="M62.636 85.851c.815 1.714.784 3.553.79 5.386-1.549-1.607-.723-3.562-.79-5.386z"
        />
        <path
          fill="#FA2777"
          d="M131.521 88.257l.005-7.001c-.845-1.336-1.236-2.671.007-4.003.809.437.975 1.189.993 2.015l.007 9.98-.221 2.16c-.204-.021-.407-.044-.61-.066l-.181-3.085z"
        />
        <path
          fill="#E12489"
          d="M101.361 59.66c3.941-1.815 7.723.355 11.588.469 2.915 2.729 6.089 3.271 9.581 1.138 2.125 1.075 4.435-.036 6.916 1.315 2.853 1.556 3.252 3.121 3.068 5.669-1.766-.038-1.481.932-.985 2.005-1.15 1.045-2.311.408-3.064-.349-4.056-4.07-9.739-2.041-14.369-3.938-.938-.385-1.559 1.075-2.548 1.241-3.073-2.95-6.534-5.38-10.187-7.55z"
        />
        <path
          fill="#C333A1"
          d="M124.689 58.231l-.272-4.914 1.131.948c-.141 1.354.42 2.859-.859 3.966z"
        />
        <path
          fill="#E61E7F"
          d="M111.548 67.21c.624-2.629 1.598-2.716 4.513-2.223 5.548.939 10.837 1.927 15.469 5.269v5.994c-2.962.107-5.262-1.73-7.386-3.215-3.132-2.188-6.104-3.036-9.664-1.682-.978-1.38-1.956-2.761-2.932-4.143z"
        />
        <path
          fill="#EB1D78"
          d="M114.479 71.354c5.078-6.847 8.343 1.42 12.582 1.79.956.084 3.356 1.491 4.468 3.106l.004 1.003-.007 4.003c-4.424-2.208-8.013-6.184-13.445-6.284-.699-.013-1.252-.058-1.686.539l-1.916-4.157z"
        />
        <path
          fill="#F52558"
          d="M74.331 78.17c.399-1.514 1.073-2.864 2.317-3.874 1.154-.498 2.391-.467 3.614-.571 8.203-.022 15.927 2.328 23.648 4.708 1.935.596 3.004 1.916 3.506 3.797.507 2.814.693 5.598-.793 8.22a3.167 3.167 0 01-1.048-1.021c-.93-3.482-3.354-4.832-6.779-5.586-7.203-1.584-14.125-4.719-21.779-3.433-1.704.285-2.375-.791-2.686-2.24z"
        />
        <path
          fill="#F7294C"
          d="M74.331 78.17c3.08 1.71 6.455 1.151 9.669.921 2.208-.158 4.581-.412 6.237.706 3.032 2.046 6.4 2.778 9.753 3.016 4.326.305 6.165 2.394 6.46 6.404-.915.567-1.895.379-2.871.252-9.066-3.768-18.523-5.712-28.331-6.035-.75-.211-1.414-.554-1.869-1.215.137-1.393-.386-2.94.952-4.049z"
        />
        <path
          fill="#F22470"
          d="M79.533 74.251c-.953.563-1.913.695-2.885.045 8.155-10.216 22.106-9.246 28.763 1.999-.521 1.501-1.143 2.969-3.021 1.447-6.951-5.629-14.768-5.41-22.857-3.491z"
        />
        <path
          fill="#FD393B"
          d="M103.474 96.048c-.88 1.599-2.151 2.732-3.903 3.3-.986-.243-1.443-1.035-1.91-1.819-6.225-3.802-12.9-5.582-20.202-4.58a4.563 4.563 0 01-2.005.447c-1.739-1.599-2.227-3.632-2.051-5.896-.462-1.563.756-1.767 1.621-1.544 8.382 2.158 17.455 1.217 25.328 5.607 1.737.968 4.32 1.436 3.122 4.485z"
        />
        <path
          fill="#FC3442"
          d="M103.474 96.048c-1.821-4.266-6.265-4.603-9.698-5.458-6.637-1.653-13.566-2.128-20.373-3.091-.883-1.757-.979-3.517-.023-5.28l2.157.047c.696.689 1.171 1.652 2.276 1.837 8.34 1.391 16.633 3.028 24.919 4.705.68.138 1.313.019 1.798-.544l1.922.953.173 1.232c-.319 2.279-1.41 4.121-3.151 5.599z"
        />
        <path
          fill="#F42062"
          d="M79.533 74.251c5.742-3.792 17.379-3.033 22.67 1.843 1.409 1.299 2.004 1.858 3.208.201.7 1.967 2.458 3.577 2.006 5.935-1.63-2.08-3.798-3.671-6.375-2.872-3.187.987-4.334-2.149-6.876-2.739-4.86-1.126-9.995-.283-14.633-2.368z"
        />
        <path
          fill="#FD422A"
          d="M75.453 93.396l1.08-1.136c7.592.521 15.063 1.578 21.998 4.994l1.039 2.094c-.381.772-1.07.979-1.855 1.01-7.121.411-14.099.093-20.318-4.036-1.206-.606-2.028-1.466-1.944-2.926z"
        />
        <path
          fill="#FD4C28"
          d="M77.396 96.321c.153-.059.348-.21.455-.163 6.324 2.811 13.323 2.423 19.863 4.199-7.557 3.635-14.417 2.272-20.318-4.036z"
        />
        <path
          fill="#FA2D43"
          d="M104.529 88.264c-2.279 3.333-4.78.177-7.162.293-6.441.313-12.297-2.759-18.646-3.052-1.143-.053-3.898-.446-3.185-3.239 10.13-.25 19.58 2.781 28.993 5.998z"
        />
        <path
          fill="#FD3C32"
          d="M98.531 97.254c-5.129-.081-9.787-2.37-14.768-3.25-2.366-.417-5.445 1.195-7.23-1.744.358-.331.661-.796 1.084-.974 2.84-1.198 19.018 2.66 21.176 5.053.113.125-.166.601-.262.915z"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
